(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ACControls", [], factory);
	else if(typeof exports === 'object')
		exports["ACControls"] = factory();
	else
		root["ACControls"] = factory();
})(this, function() {
return 